import * as React from 'react'
import cn from 'classnames'
import styles from './KvBox.module.scss'

export type KvBoxProps = {
  Key: React.ReactNode
  value: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

/**
 * Display key value pairs in a pretty box.
 * The `Key` prop is capitalized to avoid conflict with React's built-in `key` prop.
 * This component should have a `dl` tag as an ancestor to be valid HTML.
 */
export const KvBox: React.VFC<KvBoxProps> = ({ className, Key, value }) => (
  <div className={cn(styles.container, className)}>
    <dt>{Key}</dt>
    <dd>{value}</dd>
  </div>
)
